import useReducer from "../../../hooks/useReducer";
import React, { FC, memo, useEffect, useState } from "../../../lib/teact/teact";
import PasswordForm from "../../common/PasswordForm";
import Button from "../../ui/Button";
import InputText from "../../ui/InputText";
import { LotScreenSettings } from "../config/uiconfig";
import { globalDexieDb } from "../db/DexiedbLib";
import { IDaiGioChot } from "../db/model/dmdai";
import { login, resetLogin } from "../redux/loginSlice";
import { LoginApi } from "../restapi/loginApi";
import store from "../store";
import MySnackbar from "../ui/mySnackbar";
import Snackbar from "../ui/snackbar";
import '../utils/fixViewport'
import _ from 'lodash'
import './login.scss'
import { nhomTelegram } from "../globalSettings/globalVariable";
import InstallPWAButton from "../globalSettings/InstallPWAButton";
import TelegramBotLink from "../ui/TelegramBotLink";
type OwnerProps = {
    onChangeScreen: (screen: LotScreenSettings) => void;
    onLogedIn: () => void;
}

const Login: FC<OwnerProps> = ({
    onChangeScreen,
    onLogedIn
}) => {
    const [state, setState] = useState({
        isPasswordVisible: false,
        username: "",
        password: "",
        showSnackbar: false,
        snackbarMessage: ""
    })
    const handleLogin = (userName: string, password: string) => {
        let payload = { username: userName, password: password }
        store.dispatch(login(payload))
    }
    const [accessToken, setAccessToken] = useState(store.getState().login.accessToken)
    useEffect(() => {
        //store.dispatch(resetLogin(""))
        const handleLogedIn = () => {
            const curState = store.getState();
            const logedIn = curState.login.loggedIn;
            const inProgress = curState.login.inProgress;
            if (inProgress) {
                return
            }
            if (!logedIn) {
                showSnackbar("Sai tên đăng nhập hoặc mật khẩu")
            } else {
                onLogedIn()
                LoginApi.fetchDaiGioChot().then(res => {
                    if (res && res.data) {
                        const datas: IDaiGioChot[] = res.data;
                        globalDexieDb.daiGioChot.bulkPut(datas)
                    }
                })

            }
        }
        const observeStore = store.subscribe(handleLogedIn)
        return observeStore
    }, [])
    const showSnackbar = (message: string) => {
        setState((prev) => ({ ...prev, showSnackbar: true, snackbarMessage: message }))
    }
    return (
        <div id="auth-code-form" className="custom-scroll">
            <div className="auth-form">
                {/* // <TrackingMonkey
                //     code={code}
                //     codeLength={CODE_LENGTH}
                //     isTracking={isTracking}
                //     trackingDirection={trackingDirection}
                // />
                // <h1>
                //     {authPhoneNumber}
                //     <div
                //         className="auth-number-edit div-button"
                //         onClick={handleReturnToAuthPhoneNumber}
                //         role="button"
                //         tabIndex={0}
                //         title={lang('WrongNumber')}
                //     >
                //         <i className="icon icon-edit" />
                //     </div>
                // </h1>
                // <p className="note">
                //     {renderText(lang(authIsCodeViaApp ? 'SentAppCode' : 'Login.JustSentSms'), ['simple_markdown'])}
                // </p> */}
                <InputText
                    // ref={inputRef}
                    id="sign-in-username"
                    label={"Tài khoản"}
                    onChange={(event) => {
                        setState((prevState) => {
                            const { target } = event
                            const username = target.value
                            return { ...prevState, username: username }
                        })
                    }}
                    value={state.username}
                    // error={authError && lang(authError)}
                    autoComplete="off"
                    inputMode="text"
                />

                <PasswordForm
                    isPasswordVisible={state.isPasswordVisible}
                    shouldShowSubmit
                    submitLabel="Đăng nhập"
                    placeholder="Mật khẩu"
                    onSubmit={(pass) => {
                        handleLogin(state.username, pass)
                    }
                    }
                    onChangePasswordVisibility={(e) => {
                        setState((prev) => ({ ...prev, isPasswordVisible: e }))
                        console.log(`onChangePasswordVisibility ${e}`)
                    }}
                    clearError={() => { }}
                ></PasswordForm>
                <div className="hotro-text">
                    <span style='font-weight:bold;'>BachKhoaSo - Công nghệ đỉnh cao</span>
                    <br/>
                    <span>Vui lòng tham gia nhóm Telegram để được hỗ trợ: </span>
                    <a href={nhomTelegram}>{nhomTelegram}</a>
                    <br/>
                     
                    <a href='https://youtube.com/@bachkhoaso?si=cm3oBbK522GutSAk'>videos hướng dẫn</a>
                    <InstallPWAButton />
                </div>
                {/* {authIsLoading && <Loading />} */}
                <TelegramBotLink username="bachkhoaAIbot" />
            </div>
            <Snackbar isOpen={state.showSnackbar} message={state.snackbarMessage} triggerTime={Date()}
                onClose={() => { setState((prev) => ({ ...prev, showSnackbar: false })) }}
            />

            {/* <MySnackbar /> */}
        </div>
    )
}

export default memo(Login);